var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLOW---MOBILE/DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Denuncia-Sinistro---MeteoAvverso---Uploaded",
    transform: "translate(-786.000000, -511.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(204.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Delete",
    transform: "translate(565.666667, 1.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:trash-can-copy-5",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 16.6666667,
    height: 16.6666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.388889, 1.388889)",
    stroke: "#7C2D35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.66666667
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.38888889,2.77777796 L12.5,2.77777796 L11.4027778,12.652778 C11.3249006,13.3564556 10.7301961,13.8888891 10.0222222,13.8888891 L3.86666667,13.8888891 C3.15869275,13.8888891 2.56398824,13.3564556 2.48611111,12.652778 L1.38888889,2.77777796 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71180556,0.796527961 C3.94110006,0.310258256 4.43043655,-4.4408921e-16 4.96805556,-4.4408921e-16 L8.92083333,-4.4408921e-16 C9.45870331,-0.000275408285 9.94837627,0.310031158 10.1777778,0.796527961 L11.1111111,2.77777796 L2.77777778,2.77777796 L3.71180556,0.796527961 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 2.77777796,
    x2: 13.8888889,
    y2: 2.77777796,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.55555556,
    y1: 6.25000018,
    x2: 5.55555556,
    y2: 9.72222241,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.33333333,
    y1: 6.25000018,
    x2: 8.33333333,
    y2: 9.72222241,
    id: "Path"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/delete.icon.242a52ec3d5fc45d1647b1633e8cc4a1.svg";
export { ForwardRef as ReactComponent };